<div *ngIf="displayFlag">  
    <span *ngIf="viewFlag"> <a href='javascript:void(0)' (click)='displayImage()'> View </a></span>  
    <span *ngIf="!viewFlag"> <a href="{{downloadUrl}}" target='_blank'> Download </a></span>
</div>